import React, { useContext } from 'react';

import { AttrsHelper } from '../../../sb-helpers/attrs-helper';
import { LayoutItem } from '../Layout/LayoutItem';
import { Layout } from '../Layout/Layout';
import { IconButton } from '../../element/Button/IconButton';

import { AccordionIconPosition } from './accordions.types';
import { AccordionsContext, AccordionsGroupContext } from './AccordionsContext';

export type AccordionsItemHeaderProps = {
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  name?: string;
  /** The press a shut heading refused. `onToggle` means the section moved; a disabled one cannot. */
  onDisabledToggle?: () => void;
  onToggle?: (expand: boolean) => void;
};
export const AccordionsItemHeader = ({
  children,
  className,
  disabled = false,
  name,
  onDisabledToggle,
  onToggle,
}: AccordionsItemHeaderProps) => {
  const { isExpanded, setIsExpanded } = useContext(AccordionsContext);
  const { icon, iconPosition } = useContext(AccordionsGroupContext);
  const isBeside = iconPosition === AccordionIconPosition.BESIDE;
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();

    if (disabled) {
      onDisabledToggle?.();

      return;
    }

    onToggle?.(!isExpanded);
    setIsExpanded(!isExpanded);
  };
  return (
    <div
      className={AttrsHelper.formatClassname('accordion-header', className)}
      data-test={name}
      onClick={handleClick}
    >
      <Layout horizontalGutter={isBeside ? '8px' : undefined} position="middle">
        {/* Slack on the heading pushes the marker to the far edge; slack after it keeps the pair together. */}
        <LayoutItem fluid={!isBeside} name="HEADER_CONTENT">
          {children}
        </LayoutItem>

        {/* One glyph turned a quarter, not two swapped - the turn is the stylesheet's, on `expanded`. */}
        {/*
          `softDisabled`, not `disabled`: the marker takes most of the row's presses, and a natively
          disabled button dispatches no click - so the refusal would be unreachable from it.
        */}
        <IconButton
          className="fixed-dimension-inline accordion-expand"
          name="expand-icon"
          pattern="secondary"
          variation="minimal"
          icon={icon}
          softDisabled={disabled}
          onClick={handleClick}
        />

        {isBeside ? <LayoutItem fluid name="HEADER_SLACK" /> : null}
      </Layout>
    </div>
  );
};
